import { render, staticRenderFns } from "./PopupSearchVirtualCompany.vue?vue&type=template&id=806222b0&scoped=true"
import script from "./PopupSearchVirtualCompany.vue?vue&type=script&lang=js"
export * from "./PopupSearchVirtualCompany.vue?vue&type=script&lang=js"
import style0 from "./PopupSearchVirtualCompany.vue?vue&type=style&index=0&id=806222b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806222b0",
  null
  
)

export default component.exports